import { render } from "./ProductFooter.vue?vue&type=template&id=f9ae980e&scoped=true"
import script from "./ProductFooter.vue?vue&type=script&lang=js"
export * from "./ProductFooter.vue?vue&type=script&lang=js"

import "./ProductFooter.vue?vue&type=style&index=0&id=f9ae980e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ae980e"]])

export default __exports__